function humanize() {
  'ngInject';
  return function(string) {

    string = string || '';

    return string.replace(/_/g, ' ');

  };
}
export { humanize };
